






















































































import Vue from "vue";
import Component from "vue-class-component";
import { Getter, Action } from "vuex-class";

import Customer, { customerInitValue } from "@/types/customer/Customer";
import UserInterface from "@/types/app/IUser";
import CustomerService from "@/services/customerService";
import { getFileNameFromLink } from "@/utils/fileName";
import Header from "@/types/app/header";
import formatDate from "@/utils/formatDate";
import Endpoint from "@/utils/endpoint";
import * as XLSX from "xlsx";
import ModalSuccess from "@/components/common/ModalSuccess.vue";
import { CustomerSelectValue } from "@/utils/getCustomers";
import AccountService from "@/services/accountService";
import AccountInterface, { accountInitialValue } from "@/types/app/accounts";
import Interest from "@/types/app/excelData";
import ErrorService from "@/services/erroService";
import BaseComponent from "@/utils/baseComponent";
import CompanyInterface from "@/types/app/companies";
import InvestorInterface from "@/types/app/investor";
import { removePageShowEventListener } from "@microsoft/applicationinsights-core-js";
import { x64 } from "crypto-js";
import { ImportCompanyHeader, ImportInvestorHeader, ImportAccountHeader } from "@/components/headers/header-import-company";
import CompanyService from "@/services/companyService";

interface ProductFund {
    fundName: string;
    fundSiteName: string;
    fundId: string;
}

interface CompanyXlsImportData {
    CompanyAlreadyExist: string;
    CompanyName: string;
    CompanyEmail: string;
    CompanyId?: string;
    CompanyCountry: string;
    hasCompanyError: boolean;
    messageCompanyErrors: string[];
    InvestorAlreadyExist: string;
    IsClientUser: string;
    InvestorName: string;
    InvestorEmail: string;
    CustomerId?: string;
    InvestorId?: string;
    hasInvestorError: boolean;
    messageInvestorErrors: string[];
    FundName: string;
    FundId?: string;
    AccountNumber: string;
    hasAccountError: boolean;
    messageAccountErrors: string[];
}

interface CompanyImport {
    companyId?: string;
    email?: string;
    name: string;
    country?: string;
    investors?: InvestorImport[];
    hasError: boolean;
    messageErrors: string[]
}

interface InvestorImport {
    name: string,
    email?: string,
    clientId?: string,
    investorId?: string,
    accounts?: AccountImport[]
    hasError: boolean;
    messageErrors: string[]
}

interface AccountImport {
    fundName: string,
    accountNumber: string,
    fundId?: string,
    customerId?: string,
    hasError: boolean;
    messageErrors: string[]
}

@Component({
    components: { ModalSuccess },
    data: () => ({
        isLCM: false,
        endpoint: new Endpoint(),
    }),
})
export default class ImportCompany extends BaseComponent {
    @Getter("getCustomersAll", { namespace: "customer" }) customersAll!: Customer[];
    height = "";
    customer: Customer = customerInitValue;
    headersCompany: Header[] = ImportCompanyHeader.header;
    headersInvestor: Header[] = ImportInvestorHeader.header;
    headersAccount: Header[] = ImportAccountHeader.header;
    private accountService = new AccountService(this.$http);
    private companyService = new CompanyService(this.$http);
    errorCreate = false;
    loading = false;
    getFileNameFromLink = getFileNameFromLink;
    formatDate = formatDate;
    private endpoint = new Endpoint();
    customerService = new CustomerService(this.$http);
    funds: ProductFund[] = [];

    companiesImport: CompanyImport[] = [];
    accountsImport: AccountImport[] = [];
    investorsImport: InvestorImport[] = [];
    companiesXlsImportErros: CompanyXlsImportData[] = [];
    companies: CompanyInterface[] = [];
    accounts: AccountInterface[] = [];
    investors: InvestorInterface[] = [];
    customers: InvestorInterface[] = [];
    errorMessage = "";
    validationMessage = "";
    headerTemplate = [
        "CompanyAlreadyExist",
        "CompanyName",
        "CompanyEmail",
        "CompanyCountry",
        "InvestorAlreadyExist",
        "IsClientUser",
        "InvestorName",
        "InvestorEmail",
        "FundName",
        "AccountNumber"
    ];

    async mounted() {
        this.loading = true;
        const [companiesResponse, customerResponse, accountResponse, fundResponse] = await Promise.all([
            this.companyService.getCompanies(),
            this.customerService.getSelectAccountCustomers(),
            this.accountService.getAccounts(),
            this.getProductFunds()
        ]);
        this.companies = companiesResponse;
        this.investors = customerResponse.filter(x => x.group?.startsWith('Investors'))
            .map(c => ({
                name: c.name, email: c.email, id: c.value,
                updatedDate: c.group
            } as InvestorInterface));
        this.customers = customerResponse.filter(x => !x.group?.startsWith('Investors'))
            .map(c => ({
                name: c.name, email: c.email, id: c.value,
                updatedDate: ""
            } as InvestorInterface));
        this.accounts = accountResponse;
        this.funds = fundResponse;
        this.loading = false;

        console.log('loadInitCompanies', this.companies);
    }

    clear() {
        this.companiesImport = [];
        this.accountsImport = [];
        this.investorsImport = [];
        this.interestsErros = [];
        this.errorMessage = "";
        this.validationMessage = "";
        this.errorCreate = false;
    }

    closeModal(): void {
        //this.setModalImportInterestState(false);
        this.clear();
    }
    interestsErros: CompanyImport[] = [];

    getRowCompanyClass(item: CompanyImport) {
        if (item.hasError
            || item.investors?.some((i) => i.hasError || i.accounts?.some((a) => a.hasError))) {
            return "invalid-row";
        }
    }

    getRowInvestorClass(item: InvestorImport) {
        if (item.hasError || item.accounts?.some((a) => a.hasError)) {
            return "invalid-row";
        }
    }

    getRowAccountClass(item: AccountImport) {
        if (item.hasError) {
            return "invalid-row";
        }
    }

    getFundId(fundName: string): string | any {
        return this.funds.find(
            (x) =>
                x.fundName.toLocaleLowerCase() == fundName.toLocaleLowerCase() ||
                x.fundSiteName.toLocaleLowerCase() == fundName.toLocaleLowerCase()
        )?.fundId;
    }


    handleFileImport() {
        // Trigger click on the FileInput
        (this.$refs.uploader as HTMLElement).click();
    }

    async save() {
        // if (!this.form().validate()) {
        //     return false;
        // }
        this.errorCreate = false;
        this.loading = true;

        try {
            let companiesSave = JSON.parse(JSON.stringify(this.companiesImport)) as CompanyImport[];
            companiesSave.forEach(c => {
                c.investors?.forEach(i => {
                    i.accounts = i.accounts?.filter(a => !a.hasError);
                })
                c.investors = c.investors?.filter(i => !i.hasError);
            })
            companiesSave = companiesSave.filter(c => !c.hasError);
            if (companiesSave.length > 0) {
                try{
                    await this.companyService.importData(companiesSave);
                }catch(excption){
                    console.log(excption);
                }
            }
            if (this.companiesXlsImportErros.length > 0) {
                const dataErrors = this.companiesXlsImportErros.map(data =>
                ({
                    ...data,
                    messageErrorsCompany: data.messageCompanyErrors.join(" and "),
                    messageErrorsInvestor: data.messageInvestorErrors.join(" and "),
                    messageErrorAccount: data.messageAccountErrors.join(" and "),
                })).map(({
                    hasAccountError,
                    hasCompanyError,
                    hasInvestorError,
                    messageAccountErrors,
                    messageCompanyErrors,
                    messageInvestorErrors,
                    CompanyId,
                    CustomerId,
                    FundId,
                    InvestorId,
                    ...rest
                }) => rest);
                this.showSuccess('Imported data from companies with some errors successfully!')
                this.download(dataErrors);
            }
            else {
                this.showSuccess('Imported Companies data with successfully!')
            }
        } finally {
            this.loading = false;
        }
    }


    existsAccounts(item: AccountImport): boolean {
        return this.accounts.some(
            (x) =>
                x.accountNumber == item.accountNumber &&
                x.fundId == item.fundId &&
                x.userId == item.customerId
        );
    }

    loadCustomers() {
        console.log('loadCustomers')
    }



    async getProductFunds(): Promise<ProductFund[]> {
        const url = this.endpoint.productFund;
        const response = await this.$http.get(`${url}?hasInvestment=false`);

        const productFunds = response.data as ProductFund[];

        return productFunds;
    }

    async getCustomers(): Promise<Customer[]> {
        const customerOrdened = [...this.customersAll];

        return customerOrdened;
    }

    async showMessageError(message: string) {
        this.showError(message);
    }

    importData(event: any) {
        const file = event.target.files ? event.target.files[0] : null;
        if (file) {
            this.clear();
            this.loading = true;
            const reader = new FileReader();
            reader.onload = (e: any) => {
                /* Parse data */
                const bstr = e.target.result;
                const wb = XLSX.read(bstr, { type: "binary" });
                /* Convert array of arrays */


                const companiesXls = XLSX.utils.sheet_to_json<CompanyXlsImportData>(
                    wb.Sheets[wb.SheetNames[0]],
                    {
                        blankrows: false,
                    }
                );
                console.log('importData', companiesXls);
                this.validationImport(companiesXls);
                console.log('validatedImport', companiesXls);
                this.loadData(companiesXls);
                this.companiesXlsImportErros = companiesXls.filter(x => x.hasAccountError || x.hasCompanyError
                    || x.hasInvestorError);
                this.loading = false;
            };

            reader.readAsBinaryString(file);
        }
    }


    validationImport(companiesXls: CompanyXlsImportData[]) {

        companiesXls.forEach(element => {
            this.validationImportCompany(element);
            this.validationImportInvestor(element);
        })

    }

    validationImportCompany(element: CompanyXlsImportData) {
        element.messageCompanyErrors = [];
        element.hasCompanyError = false;
        if (!element.CompanyName) {
            element.hasCompanyError = true;
            element.messageCompanyErrors.push('CompanyName field is required');
        }
        if (!element.CompanyAlreadyExist || (!element.CompanyAlreadyExist.toLocaleUpperCase().startsWith('Y') && !element.CompanyAlreadyExist.toLocaleUpperCase().startsWith('N'))) {
            element.hasCompanyError = true;
            element.messageCompanyErrors.push(`CompanyAlreadyExist field is required or the value must be valid (Yes or No) ${element.CompanyAlreadyExist}`);
        }

        if (!element.hasCompanyError && element.CompanyAlreadyExist.toLocaleUpperCase().startsWith('Y')) {

            const company = this.companies.find(c => c.name.trim().toUpperCase() == element.CompanyName.trim().toUpperCase());
            if (!company) {
                element.hasCompanyError = true;
                element.messageCompanyErrors.push(`Company name ${element.CompanyName} not found`)
            }
            else element.CompanyId = company.id;
        }

        if (element.CompanyEmail) {
            const valid = this.emailValidation(element.CompanyEmail);
            console.log('validEmailCompany', valid);
            if (valid != true) {
                element.hasCompanyError = true;
                element.messageCompanyErrors.push(`Company email required is valid value`);
            }
        }

    }

    validationImportInvestor(element: CompanyXlsImportData) {
        element.messageInvestorErrors = [];
        element.messageAccountErrors = [];
        element.hasInvestorError = false;
        element.hasAccountError = false;

        if (element.InvestorName || element.InvestorEmail) {
            if (element.InvestorEmail) {
                const valid = this.emailValidation(element.InvestorEmail);
                console.log('validInvestorEmail', valid);
                if (valid != true) {
                    element.hasInvestorError = true;
                    element.messageInvestorErrors.push(`Investor email required is valid value`);
                }
            }
            else {
                element.InvestorEmail = element.CompanyEmail;
            }
            if (!element.InvestorAlreadyExist
                || (!element.InvestorAlreadyExist.toLocaleUpperCase().startsWith('Y')
                    && !element.InvestorAlreadyExist.toLocaleUpperCase().startsWith('N'))) {
                element.hasInvestorError = true;
                element.messageInvestorErrors.push('InvestorAlreadyExist field is required or the value must be valid (Yes or No)');
            }
            if (!element.IsClientUser
                || (!element.IsClientUser.toLocaleUpperCase().startsWith('Y')
                    && !element.IsClientUser.toLocaleUpperCase().startsWith('N'))) {
                element.hasInvestorError = true;
                element.messageInvestorErrors.push('IsClientUser field is required or the value must be valid (Yes or No)');
            }

            if (element.IsClientUser?.toLocaleUpperCase()?.startsWith('Y')) {
                if (!element.InvestorEmail) {
                    element.hasInvestorError = true;
                    element.messageInvestorErrors.push(`InvestorEmail is required when the IsClientUser field is filled with Yes.`);
                } else {
                    const customer = this.customers.find(i => i.email.toUpperCase().trim() ==
                        element.InvestorEmail.toUpperCase().trim());
                    if (!customer) {
                        element.hasInvestorError = true;
                        element.messageInvestorErrors.push(`Customer not found with email ${element.InvestorEmail}.`)
                    }
                    else {
                        element.CustomerId = customer.id;
                        element.InvestorName = customer.name;
                        element.InvestorEmail = customer.email;
                    }
                }
            }
            else {

                if (!element.hasInvestorError && !element.InvestorName) {
                    element.hasInvestorError = true;
                    element.messageInvestorErrors.push('InvestorName field is required or the value must be valid (Yes or No)');
                }
                else if (element.InvestorAlreadyExist.toLocaleUpperCase().startsWith('Y')
                ) {
                    const investor = this.investors.find(i => i.name.toUpperCase().trim() ==
                        element.InvestorName.toUpperCase().trim()
                        && i.updatedDate.toUpperCase().trim() == `Investor - ${element.CompanyName}`.toUpperCase().trim());
                    if (!investor) {
                        element.hasInvestorError = true;
                        element.messageInvestorErrors.push(`Investor name ${element.InvestorName} not found`)
                    }
                    else element.InvestorId = investor.id;
                }
            }


            if (element.FundName && element.AccountNumber) {
                const fund = this.funds.find(x => x.fundName?.toUpperCase()?.trim()
                    == element.FundName.toUpperCase().trim() ||
                    x.fundSiteName?.toUpperCase()?.trim()
                    == element.FundName.toUpperCase().trim()
                );
                if (!fund) {
                    element.hasAccountError = true;
                    element.messageAccountErrors.push(`FundName ${element.FundName} is not found`);
                }
                else element.FundId = fund.fundId;
            }
            else {
                if (element.FundName && !element.AccountNumber) {
                    element.hasAccountError = true;
                    element.messageAccountErrors.push(`AccountNumber is required when FundName is filled`);
                }

                if (!element.FundName && element.AccountNumber) {
                    element.hasAccountError = true;
                    element.messageAccountErrors.push(`FundName is required when AccountNumber is filled`);
                }
            }
        }
    }

    loadData(companiesXls: CompanyXlsImportData[]) {
        companiesXls.forEach(row => {
            let company = this.companiesImport.find(x => x.name.trim() == row.CompanyName?.trim());
            if (!company) {
                company = {
                    name: row.CompanyName?.trim(),
                    email: row.CompanyEmail?.trim(),
                    country: row.CompanyCountry?.trim(),
                    hasError: row.hasCompanyError,
                    messageErrors: row.messageCompanyErrors
                };
                if (row.CompanyId)
                    company.companyId = row.CompanyId;
                this.companiesImport.push(company);
            }
            if (row.InvestorName || row.CustomerId) {
                let investor = company.investors?.find(i => i.name?.trim() == row.InvestorName?.trim())
                if (!investor) {
                    investor = {
                        name: row.InvestorName.trim(), email: row.InvestorEmail?.trim(),
                        clientId: row.CustomerId, investorId: row.InvestorId,
                        hasError: row.hasInvestorError,
                        messageErrors: row.messageInvestorErrors
                    };
                    if (!company.investors) {
                        company.investors = [];
                    }
                    company.investors.push(investor);
                    console.log('loadDataCompanyInvestor', company);
                }

                if (row.FundName && row.AccountNumber) {
                    let account = investor?.accounts?.find(f => f.fundName?.trim() == row.FundName.trim()
                        && f.accountNumber?.trim() == row.AccountNumber);
                    if (!account) {
                        account = {
                            accountNumber: row.AccountNumber,
                            fundName: row.FundName,
                            customerId: row.CustomerId,
                            hasError: row.hasAccountError,
                            fundId: row.FundId,
                            messageErrors: row.messageAccountErrors
                        }
                        if (!investor.accounts)
                            investor.accounts = [];
                        investor.accounts.push(account);
                    }
                }
            }
        });
        console.log('loadData', this.companiesImport);
    }

    download(interests: any[]) {
        const nameTemplate =
            interests.length > 0 ? "import_errors_" : "template_export_";
        const dataInterestJson = XLSX.utils.json_to_sheet(interests, {
            header: this.headerTemplate,
        });

        const wbInterest = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wbInterest, dataInterestJson, "BulkCompanies");
        XLSX.writeFile(wbInterest, nameTemplate + new Date().getTime() + ".xlsx");
    }
}
